import styled from 'styled-components'
import { List } from '@gympass/yoga'

import SMBContainer from '@components/Container'
import { H2, H4, H6, Body1 } from '@components/Typography'

import getBreakpoint from '@client/utils/breakpoints'

export const Container = styled(SMBContainer)`
  @media (min-width: ${getBreakpoint('md')}px) and (max-width: ${getBreakpoint(
      'lg'
    )}px) {
    max-width: 479px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Title = styled(H2)`
  font-weight: ${({ thin }) => (thin ? '300' : '900')};

  strong {
    font-weight: 900;
  }
`

export const Subtitle = styled(Body1)`
  margin-top: 8px;
`

export const ListTitle = styled(H4)`
  margin-top: 40px;
  margin-bottom: 24px;
  font-weight: 900;

  @media (min-width: ${getBreakpoint('md')}px) {
    margin-top: 56px;
  }
`

export const ListWrapper = styled(List)`
  padding: 0;
`

export const ListItem = styled(List.Item)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0;
  margin-right: auto;
  margin-bottom: 40px;

  @media (min-width: 768px) {
    margin-bottom: 48px;
  }
`

export const ListItemContent = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 11px;
`

export const ListItemTitle = styled(H6)`
  margin-bottom: 4px;
  font-weight: 900;
  line-height: 19px;
  color: #232c7b;
`

export const ListItemDescription = styled.p`
  color: #001027;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
`

export const ListItemNumber = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 40px;
  height: 40px;
  margin-right: 16px;

  border: 1px solid #232c7b;
  border-radius: 100%;

  font-family: Lato;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 29px;
  color: #232c7b;
`

export const ListItemIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  margin-right: 8px;

  img {
    width: 24px;

    @media (min-width: ${getBreakpoint('md')}px) {
      width: 32px;
    }
  }
`
